/**
 * BLOCK: How-to Child
 */

import WPSPBlockIcons from '@Controls/block-icons';
import edit from './edit';
import save from './save';
import attributes from './attributes';
import './style.scss';
import deprecated from './deprecated';
import { registerBlockType } from '@wordpress/blocks';

registerBlockType('wpsp/how-to-child', {
	title: wpsp_blocks_info.blocks['wpsp/how-to-child'].title,
	description: wpsp_blocks_info.blocks['wpsp/how-to-child'].description,
	icon: WPSPBlockIcons.how_to,
	parent: ['wpsp/how-to'],
	supports: {
		anchor: true,
	},
	category: wpsp_blocks_info.category,
	example: {
		innerBlocks: [
			{
				name: 'wpsp/how-to-child',
				attributes: {
					howtoChildTitle: 'Enter a step title',
					headingDesc:
						'So to get started, you will just need to drag-n-drop the How-to Schema block in the Gutenberg editor.',
					iconimgPosition: 'left',
				},
			},
			{
				name: 'wpsp/how-to-child',
				attributes: {
					howtoChildTitle: 'Enter a step title',
					headingDesc:
						'So to get started, you will just need to drag-n-drop the How-to Schema block in the Gutenberg editor.',
					iconimgPosition: 'left',
				},
			},
		],
	},
	attributes,
	deprecated,
	edit,
	save,
});
